import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PortalModule } from "@angular/cdk/portal";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ActionSidenavService } from "./action-sidenav.service";

@Component({
  selector: "jtms-action-sidenav",
  imports: [CommonModule, PortalModule, MatIconModule, MatButtonModule, MatTooltipModule],
  template: `
    <div class="action-container">
      @if (actionSidenavService.portal(); as portal) {
        <ng-template [cdkPortalOutlet]="portal"></ng-template>
      } @else {
        <div class="no-actions">
          <mat-icon>info_outline</mat-icon>
        </div>
      }

      <div class="action-list-footer">
        <button
          class="action-list-footer-button"
          mat-icon-button
          (click)="actionSidenavService.toggle()"
          matTooltip="Hide side panel"
          matTooltipPosition="below"
        >
          <mat-icon>last_page</mat-icon>
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        height: 100%;
        width: 100%;
      }

      .action-container {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
      }

      .action-list-footer {
        margin-top: auto;
        padding-bottom: 16px;
        display: flex;
        justify-content: center;
        width: 100%;
      }

      .action-list-footer-button {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;

        width: 40px !important;
        height: 40px !important;
        padding: 0 !important;
        min-width: 0 !important;

        ::ng-deep .mat-icon {
          margin: 0 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 20px !important;
          height: 20px !important;
          font-size: 20px !important;
        }

        ::ng-deep .mat-mdc-button-touch-target {
          width: 40px !important;
          height: 40px !important;
          left: 50% !important;
          top: 50% !important;
          transform: translate(-50%, -50%) !important;
        }
      }

      .no-actions {
        display: flex;
        justify-content: center;
        opacity: 0.4;
        margin-top: 24px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionSidenav {
  protected readonly actionSidenavService = inject(ActionSidenavService);
}
